type Cacheability = {
  tagsCdn: string[]
  maxAge: number
}

export function useGraphqlCacheability(
  v: Cacheability | { cacheability?: Cacheability | null } | null,
) {
  if (import.meta.server) {
    const event = useRequestEvent()
    if (!event) {
      return
    }
    const cacheability: Cacheability | null | undefined =
      v && 'maxAge' in v ? v : v?.cacheability

    useCDNHeaders((cdn) => {
      if (cacheability) {
        cdn
          .setNumeric('maxAge', cacheability?.maxAge)
          .addTags(cacheability.tagsCdn)
      }
    })
  }
}
